// extracted by mini-css-extract-plugin
export default {"wrapper":"sp-z","response":"tp-z","error":"up-z","disabled":"vp-z","buttons":"wp-z","feedbackQuestionSection":"xp-z","yesNoWrapper":"yp-z"};